import { Button, Col, Modal, Row, Toast } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import SlideForm from './slideForm';
import useHttpApiCall from '../../services/useHttpApiCall';
import { SlideShow } from './slideShow';

function ResponsiveExample({ isSlides, dataList, tableData, setReloadData = () => {} }) {
  const [showModal, setShowModal] = useState(false);
  const [deletePayload, setDeletePayload] = useState(undefined);
  const [editForm, setEditForm] = useState(false);
  const [editData, setEditData] = useState({});
  const [deleteModalVisibility, setDeleteModalVisibility] = useState(false);
  const [deletedItem, setDeletedItem] = useState({});
  const [slideShowClick, setSlideShowClick] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isElementVisible, setIsElementVisible] = useState(true);
  const [selectedSlideShow, setSelectedSlideShow] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [data] = useHttpApiCall(deletePayload);
  const is_shopfloor_viewer = localStorage.getItem('is_shopfloor_viewer') == 'true' ? true : false;

  const handleShow = () => {
    setShowModal(true);
    setEditData({});
    setEditForm(false);
  };
  const handleClose = () => setShowModal(false);
  const handleCloseDeleteModal = () => {
    setDeletedItem({});
    setDeleteModalVisibility(false);
  };

  useEffect(() => {
    const onFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement); // Check if fullscreen is active
    };

    // onKeyDown listens for Escape key press to hide the button or take actions
    const onKeyDown = (e) => {
      if (e.key === 'Escape') {
        if (isElementVisible) {
          // Logic when the button is visible and Escape is pressed
          setIsElementVisible(false); // Hide the button or perform an action
        } else {
          setIsElementVisible(true); // Show the button when Escape is pressed again
        }
      }
    };

    // Listen to fullscreen change and Escape key press
    document.addEventListener('fullscreenchange', onFullscreenChange);
    document.addEventListener('keydown', onKeyDown);

    // Cleanup listeners when component unmounts
    return () => {
      document.removeEventListener('fullscreenchange', onFullscreenChange);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [isElementVisible]); // Only rerun the effect when fullscreen state changes

  const onAlertDeleteConfirm = () => {
    isSlides
      ? setDeletePayload({
          auth: true,
          url: `v0/shop-floor-view/slides/${deletedItem?.id}/`,
          method: 'DELETE'
        })
      : setDeletePayload({
          auth: true,
          url: `v0/shop-floor-view/slide-shows/${deletedItem?.id}/`,
          method: 'DELETE'
        });
  };

  useEffect(() => {
    data?.status == 204 && setReloadData();
    data?.status == 204 && setDeletePayload({});
  }, [data]);

  //handle delete
  const handleDelete = (item) => {
    setDeletedItem(item);
    setDeleteModalVisibility(true);
  };

  //to show success delete message
  useEffect(() => {
    if (data?.status === 204) {
      setToastMessage('Deleted successfully');
      setShowToast(true);
    }
  }, [data]);
  const truncateText = (text) => {
    // If the text length exceeds the max length, truncate and add "..."
    // if (text.length > maxLength) {
    //   return text.slice(0, maxLength) + "...";
    // }
    return text;
  };

  const handleFullscreen = () => {
    const el = document.getElementById('element');
    if (el.requestFullscreen) {
      el.requestFullscreen();
    } else if (el.mozRequestFullScreen) {
      // Firefox
      el.mozRequestFullScreen();
    } else if (el.webkitRequestFullscreen) {
      // Chrome, Safari and Opera
      el.webkitRequestFullscreen();
    } else if (el.msRequestFullscreen) {
      // IE/Edge
      el.msRequestFullscreen();
    }
    setIsElementVisible(true);
    setIsFullscreen(true);
  };

  const handleExitFullscreen = () => {
    setSelectedSlideShow(null);
    setSlideShowClick(false);

    if (isFullscreen) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        // Firefox
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        // Chrome, Safari, and Opera
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        // IE/Edge
        document.msExitFullscreen();
      }
    }

    setIsElementVisible(false); // Hide the element when exiting fullscreen
    setIsFullscreen(false);
  };

  useEffect(() => {
    const onFullscreenChange = () => {
      if (!document.fullscreenElement) {
        setIsFullscreen(false);
        setIsElementVisible(false);
        setSlideShowClick(false);
        setSelectedSlideShow(null);
      }
    };

    const onKeyDown = (e) => {
      if (e.key === 'Escape') {
        handleExitFullscreen();
      }
    };

    document.addEventListener('fullscreenchange', onFullscreenChange);
    document.addEventListener('keydown', onKeyDown);

    return () => {
      document.removeEventListener('fullscreenchange', onFullscreenChange);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, []);

  return (
    <div className="shopfloor">
      <Modal show={deleteModalVisibility} onHide={handleCloseDeleteModal} centered>
        <div className="modal-wrap">
          <Modal.Header closeButton>
            <h5>Delete Alert!</h5>
          </Modal.Header>
          <Modal.Body>Are you sure you want to delete?</Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              className="btn-grad"
              onClick={() => {
                onAlertDeleteConfirm();
                handleCloseDeleteModal();
              }}>
              Confirm
            </Button>
            <Button variant="secondary" onClick={handleCloseDeleteModal}>
              Cancel
            </Button>
          </Modal.Footer>
        </div>
      </Modal>
      <div className="">
        <Row className="pt-2 pb-2 shopfloor-row" style={{ borderBottom: '1px solid red' }}>
          <Col className="ps-0 semi-bold text-muted " lg={2} md={3} sm={4}>
            <span>Name</span>{' '}
          </Col>
          <Col className="ps-0 semi-bold text-muted" lg={8} md={7} sm={6}>
            {' '}
            {!isSlides ? 'Slides' : 'Equipment'}{' '}
          </Col>
          <Col className="ps-0 semi-bold text-muted" align="center" lg={2} md={2} sm={2}>
            <span className="semi-bold">Actions</span>{' '}
          </Col>
        </Row>
        {isSlides
          ? tableData?.map((item) => (
              <Row key={item?.id} className="pt-2 pb-2 each-prev-emission-factor shopfloor-row">
                <Col className="boldNames ps-0" lg={2} md={3} sm={4}>
                  {item?.name}
                </Col>
                <Col className="boldNames ps-0" lg={8} md={5} sm={4}>
                  {item?.equipment?.length > 0 ? (
                    item?.equipment?.map((slide, index) => (
                      <div className="itemSlides" key={slide?.source_mapping}>
                        {truncateText(slide?.equipment_name)}
                        {index < item.equipment.length - 1 ? ', ' : ''}
                      </div>
                    ))
                  ) : (
                    <div className="itemSlides">No equipment...</div>
                  )}
                </Col>
                <Col align="center" lg={2} md={1} sm={1}>
                  {!is_shopfloor_viewer && (
                    <i
                      className="medium material-icons notranslate itemIcons editIcon"
                      title="Edit"
                      onClick={() => {
                        handleShow();
                        setEditData(item);
                        setEditForm(true);
                      }}>
                      edit
                    </i>
                  )}
                  {!is_shopfloor_viewer && (
                    <i
                      className="medium material-icons notranslate itemIcons delete"
                      title="Delete"
                      onClick={() => handleDelete(item)}>
                      delete
                    </i>
                  )}
                </Col>
              </Row>
            ))
          : tableData?.map((item) => (
              <Row
                key={item?.id}
                className="pt-2 pb-2 each-prev-emission-factor shopfloor-row align-items-center">
                <Col className="boldNames ps-0" lg={2} md={3} sm={4}>
                  {item?.name}
                </Col>
                <Col className="boldNames ps-0" lg={8} md={5} sm={4}>
                  {item?.slides.length > 0 ? (
                    item?.slides?.map((slide, index) => (
                      <div className="itemSlides" key={slide?.slide}>
                        {slide?.slide_name}
                        {index < item.slides.length - 1 ? ', ' : ''}
                      </div>
                    ))
                  ) : (
                    <div className="itemSlides">No slides...</div>
                  )}
                </Col>
                {!is_shopfloor_viewer && (
                  <Col lg={2} md={4} sm={4} className="d-flex justify-content-end gap-2">
                    <i
                      className="small material-icons notranslate itemIcons editIcon"
                      title="Edit"
                      onClick={() => {
                        handleShow();
                        setEditData(item);
                        setEditForm(true);
                      }}>
                      edit
                    </i>
                    <i
                      className="small material-icons notranslate itemIcons delete"
                      title="Delete"
                      onClick={() => handleDelete(item)}>
                      delete
                    </i>
                    <i
                      className="small material-icons notranslate itemIcons editIcon"
                      title="Fullscreen display"
                      onClick={() => {
                        setSlideShowClick(true);
                        handleFullscreen();
                        setSelectedSlideShow(item?.id);
                      }}>
                      play_arrow
                    </i>
                    <i
                      className="material-symbols-outlined"
                      title="Display in new window"
                      role="button"
                      tabIndex={0}
                      onClick={() => {
                        window.open(`/slideShow/${item?.id}?full_windowed=1`, '_blank');
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          window.open(`/slideShow/${item?.id}?full_windowed=1`, '_blank');
                        }
                      }}>
                      featured_video
                    </i>
                  </Col>
                )}
                {is_shopfloor_viewer && (
                  <Col className="ps-0" align="center">
                    <i
                      className="small material-icons notranslate itemIcons editIcon"
                       title="Fullwindow display" 
                       role="button"
                       tabIndex={0}
                      onClick={() => {
                        setSlideShowClick(true);
                        handleFullscreen();
                        setSelectedSlideShow(item?.id);
                      }}>
                      play_arrow
                    </i>
                    <i
                      className="small material-icons notranslate itemIcons editIcon"
                      onClick={() => {
                        window.open(`/slideShow/${item?.id}?full_windowed=1`, '_blank');
                      }}
                      title="Display in new window">
                      open_in_new
                    </i>
                  </Col>
                )}
              </Row>
            ))}

        <div className="addNewButton">
          {!is_shopfloor_viewer && (
            <Button className="btn-grad btn btn-primary " onClick={handleShow}>
              Add
            </Button>
          )}
        </div>
      </div>
      <SlideForm
        show={showModal}
        editForm={editForm}
        editData={editData}
        dataList={dataList}
        handleCloseModal={handleClose}
        slides={isSlides}
        heading={isSlides ? 'Create Slide' : 'Create slide show'}
        subHeading={
          isSlides
            ? 'Create a slide with one or more equipment.'
            : 'Create a slide show with one or more slides.'
        }
        setReloadData={setReloadData}
      />
      <div id="element" className="element">
        {slideShowClick && selectedSlideShow && (
          <SlideShow
            click={slideShowClick}
            isFullscreen={isFullscreen}
            handleExitFullscreen={handleExitFullscreen}
            id={selectedSlideShow}
          />
        )}
      </div>
      <Toast
        onClose={() => setShowToast(false)}
        show={showToast}
        delay={12000}
        autohide
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          minWidth: '250px',
          zIndex: 9999,
          textAlign: 'center',
          backgroundColor: '#ddf0ce',
          borderColor: '#bbe19d',
          color: '#4E4E4E'
        }}>
        <Toast.Body>{toastMessage}</Toast.Body>
      </Toast>
    </div>
  );
}

export default ResponsiveExample;
